export const AuthRecursosDigitals = ({auth, handleChange, error }) => 
{

return (
        <div className="row">
        <div className="col col-12 ">
        <h4>
            Ús de serveis i recursos digitals a internet per treballar a l’aula
        </h4>
        <p>
            Que estic assabentat/ada que el meu fill/a o jo mateix, utilitzarà per al treball acadèmic, els serveis telemàtics i/o aplicacions de 
            dispositius mòbils que requereixen usuari i contrasenya que s’especifiquen a continuació: plataforma de gestió educativa iEduca, 
            plataforma LMS Moodle, correu electrònic corporatiu i Google Workspace for Education.
        </p>

        <p>
            La creació d’aquests identificadors i la responsabilitat de l’ús que se’n faci en l’àmbit escolar corresponen al centre educatiu. 
            El centre no es fa responsable, però, de l’ús indegut del recurs i dels continguts per part dels usuaris: l’usuari serà l’únic 
            responsable de les infraccions en què pugui incórrer o dels perjudicis que pugui causar per un ús inadequat dels serveis o dels continguts.
        </p>

        <p>
            <input type="checkbox" id="authRecursosDigitals" name="authRecursosDigitals" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange(t.target.value) } } required/>
            <label htmlFor="authRecursosDigitals"> Declaro que estic assabentat/da i accepto les condicions d’ús</label>
            <span id="auhtRecursosDigitals_ERROR" className="a-Form-error">{error}</span>
        </p>


        </div>
    </div>
     )
}